import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Wellness: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#ff612b}'}</style>
    <path
      d="M12.38 23.42c5.15 0 9.588 3.073 11.603 7.478 2.015-4.405 6.453-7.478 11.604-7.478h.438c.497-3.181-.44-6.463-2.924-8.983l-4.815 3.82c-2.237 1.774-3.673 4.037-4.303 6.415-.63-2.378-2.066-4.641-4.302-6.415l-4.815-3.82c-2.485 2.52-3.422 5.802-2.925 8.983h.438z"
      style={{
        fill: '#002677',
      }}
    />
    <path
      d="M23.997 21.56c.86-1.582 2.063-3.002 3.56-4.194a15.484 15.484 0 0 0-3.56-5.55 15.486 15.486 0 0 0-3.56 5.55c1.497 1.192 2.7 2.612 3.56 4.193zM12.393 24.58h-7.89c0 6.408 5.196 11.604 11.604 11.604h7.89c0-6.41-5.195-11.604-11.604-11.604zM35.6 24.58c-6.408 0-11.603 5.195-11.603 11.604h7.89c6.408 0 11.603-5.196 11.603-11.604H35.6z"
      className="st1"
    />
  </Box>
)
export default Wellness
